import { render } from "./AllTasksPage.vue?vue&type=template&id=6996a373&scoped=true"
import script from "./AllTasksPage.vue?vue&type=script&lang=js"
export * from "./AllTasksPage.vue?vue&type=script&lang=js"

import "./AllTasksPage.vue?vue&type=style&index=0&id=6996a373&scoped=true&lang=scss"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6996a373"]])

export default __exports__